import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Loader2 } from "lucide-react";

// Public "How to Use" page. Content is authored by an admin (HTML/CSS/JS) and rendered
// inside a sandboxed iframe (no allow-same-origin) — the custom JS cannot reach the parent
// app, tokens, secrets or user data. Starts blank until an admin publishes content.
export default function HowToUse() {
  const [doc, setDoc] = useState(null);
  const [published, setPublished] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const r = await api.howtoLive(); setDoc(r.html || ""); setPublished(!!r.published); }
      catch { setDoc(""); }
      setLoading(false);
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="howto-page">
      <Navbar />
      {loading ? (
        <div className="flex h-[60vh] items-center justify-center"><Loader2 className="animate-spin text-[#00F0FF]" /></div>
      ) : (
        <div className="mx-auto max-w-[1100px] px-0">
          {!published ? (
            <div className="flex h-[60vh] flex-col items-center justify-center px-6 text-center" data-testid="howto-empty">
              <h1 className="font-display text-3xl font-black tracking-tight">How to Use</h1>
              <p className="mt-3 max-w-md text-sm text-[#A1A1AA]">This guide is coming soon.</p>
            </div>
          ) : (
            <iframe
              title="How to Use"
              data-testid="howto-iframe"
              sandbox="allow-scripts allow-popups allow-forms"
              srcDoc={doc}
              className="h-[calc(100vh-56px)] w-full border-0 bg-white"
            />
          )}
        </div>
      )}
    </div>
  );
}
